import { createBrowserRouter } from "react-router-dom";

import { AnswerFirstRecipientsPage } from "./routes/AnswerFirstRecipientsPage";
import { CompaniesPage } from "./routes/CompaniesPage";
import { CoveragePage } from "./routes/coverage/CoveragePage";
import { DispatchPage } from "./routes/dispatch/DispatchPage";
import { FacilitiesPage } from "./routes/FacilitiesPage";
import { HomePage } from "./routes/HomePage";
import { NotFoundPage } from "./routes/NotFoundPage";
import { RequireAdmin } from "./routes/RequireAdmin";
import { RequireAuth } from "./routes/RequireAuth";
import { RootLayout } from "./routes/RootLayout";
import { RouteErrorPage } from "./routes/RouteErrorPage";
import { UsersPage } from "./routes/UsersPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    // Catches anything that breaks the layout itself.
    errorElement: <RouteErrorPage />,
    children: [
      {
        element: <RequireAuth />,
        // Page errors render here, inside the layout, so the nav stays usable.
        errorElement: <RouteErrorPage />,
        children: [
          {
            element: <RequireAdmin />,
            children: [
              { index: true, element: <HomePage /> },
              { path: "facilities", element: <FacilitiesPage /> },
              { path: "companies", element: <CompaniesPage /> },
              { path: "coverage", element: <CoveragePage /> },
              { path: "dispatch", element: <DispatchPage /> },
              { path: "users", element: <UsersPage /> },
              {
                path: "answer-first-recipients",
                element: <AnswerFirstRecipientsPage />,
              },
            ],
          },
          { path: "*", element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);
